export default "__VITE_ASSET__CxMkB4$t__"